import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'Unusual Order Time',
    id: 'zqLOq1',
    description: 'Title for unusual order time card',
  },
  description: {
    defaultMessage: 'Flag orders placed during unusual hours when most legitimate customers are not active.',
    id: '4UXIUr',
    description: 'Description for unusual order time feature',
  },
  flagOrdersBetween: {
    defaultMessage: 'Flag orders placed between',
    id: '1ljWts',
    description: 'Label for time range selection',
  },
  and: {
    defaultMessage: 'and',
    id: 'CjaElD',
    description: 'Conjunction between start and end time',
  },
});
